import React from "react";
export default {
  "9142B": [
    {
      Header: "City",
      id: "worksiteCity",
      accessor: (d) => d["worksiteCity"],
      minWidth: 160,
      maxWidth: 170,
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "State",
      id: "worksiteState",
      accessor: (d) => d["worksiteState"],
      fixedWidth: 220,
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "County",
      id: "worksiteCountyTownship",
      accessor: (d) => d["worksiteCountyTownship"],
      minWidth: 250,
      maxWidth: 260,
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "MSA Name / OES Area Title",
      id: "worksiteBlsArea",
      accessor: (d) => d["worksiteBlsArea"],
      Cell: (props) => <span>{props.value}</span>,
    },
  ],
  "9142C": [
    {
      Header: "City",
      id: "worksiteCity",
      accessor: (d) => d["worksiteCity"],
      minWidth: 160,
      maxWidth: 170,
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "State",
      id: "worksiteState",
      accessor: (d) => d["worksiteState"],
      fixedWidth: 220,
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Postal Code",
      id: "worksitePostalCode",
      accessor: (d) => d["worksitePostalCode"],
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
  ],
  9089: [
    {
      Header: "City",
      id: "worksiteCity",
      accessor: (d) => d["worksiteCity"],
      minWidth: 160,
      maxWidth: 170,
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "State",
      id: "worksiteState",
      accessor: (d) => d["worksiteState"],
      fixedWidth: 220,
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "County",
      id: "worksiteCountyTownship",
      accessor: (d) => d["worksiteCountyTownship"],
      minWidth: 250,
      maxWidth: 260,
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "MSA / OES Area Code",
      id: "worksiteBlsAreaCode",
      accessor: (d) => d["worksiteBlsAreaCode"],
      Cell: (props) => <span>{props.value}</span>,
    },
    {
      Header: "MSA Name / OES Area Title",
      id: "worksiteBlsArea",
      accessor: (d) => d["worksiteBlsArea"],
      Cell: (props) => <span>{props.value}</span>,
    },
  ],
};
